import { MrMenu } from '@mrhenry/wp--mr-interactive';

customElements.define( 'mr-menu', MrMenu );
